var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      staticStyle: { "flex-direction": "row", padding: "20px 20px 10px 20px" }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            disabled: _vm.readonly,
            inline: true,
            "label-width": "90px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Message.TcDeliveryAddress")))
              ]),
              _c("cargo-rich-textarea", {
                staticStyle: { height: "270px", width: "500px" },
                attrs: { disabled: _vm.readonly },
                nativeOn: {
                  dblclick: function($event) {
                    _vm.showAdvanceTextDialog(
                      _vm.$t("Message.TcDeliveryAddress"),
                      _vm.form.deliveryAddress,
                      function(val) {
                        _vm.form.deliveryAddress = val
                      }
                    )
                  }
                },
                model: {
                  value: _vm.form.deliveryAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "deliveryAddress", $$v)
                  },
                  expression: "form.deliveryAddress"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "198px" },
            attrs: { disabled: _vm.readonly },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readonly,
                      expression: "!readonly"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }